"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualDataHelper = void 0;
const events_1 = require("../../../events");
class ManualDataHelper {
    static createEmptyEntry() {
        return { id: '', input: '', output: '', category: '' };
    }
    static validateAndAddEntry(currentEntry, manualData, isEditingIndex, manualDataService, emit) {
        const validation = manualDataService.validateEntry(currentEntry);
        if (!validation.isValid) {
            emit(events_1.trainerEvents.uploadError, {
                error: validation.errors.join(', ')
            });
            return { success: false };
        }
        let updatedData;
        let updatedIndex = -1;
        if (isEditingIndex >= 0) {
            // Update existing entry
            updatedData = manualDataService.updateEntry(manualData, isEditingIndex, currentEntry);
        }
        else {
            // Add new entry
            updatedData = manualDataService.addEntry(manualData, currentEntry);
        }
        return { success: true, updatedData, updatedIndex };
    }
    static removeEntry(manualData, index, isEditingIndex, manualDataService) {
        const updatedData = manualDataService.removeEntry(manualData, index);
        let updatedEditingIndex = isEditingIndex;
        if (isEditingIndex === index) {
            updatedEditingIndex = -1;
        }
        else if (isEditingIndex > index) {
            updatedEditingIndex--;
        }
        return { updatedData, updatedEditingIndex };
    }
    static duplicateEntry(manualData, index, manualDataService) {
        return manualDataService.duplicateEntry(manualData, index);
    }
    static importTemplate(manualData, template, manualDataService) {
        const templateData = manualDataService.importFromTemplate(template);
        return [...manualData, ...templateData];
    }
    static updateStatisticsAndEmit(data, validationService, emit) {
        const statistics = validationService.calculateDataStatistics(data);
        const validation = validationService.validateData(data);
        emit(events_1.trainerEvents.dataUploaded, {
            file: null,
            data,
            validation,
            statistics
        });
        return { validation, statistics };
    }
    static exportData(manualData, fileProcessingService, emit) {
        if (manualData.length === 0) {
            emit(events_1.trainerEvents.uploadError, { error: 'trainer.upload.manual.export.empty'.t() });
            return;
        }
        const csvContent = fileProcessingService.exportToCSV(manualData);
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `training-data-${Date.now()}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }
}
exports.ManualDataHelper = ManualDataHelper;
